module.exports = __webpack_public_path__ + "img/dentist-about-us.9a7bd9a1.jpg";